import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManager from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { CircularProgress } from "@material-ui/core";
import { getBackendUrl } from "../../config";
const logo = "/logo-light.png";
const logoDark = "/logo-dark.png";

const defaultTicketsManagerWidth = 550;
const minTicketsManagerWidth = 404;
const maxTicketsManagerWidth = 700;

const useStyles = makeStyles((theme) => ({
	chatContainer: {
		flex: 1,
		padding: 12,
		height: "100%",
		overflowY: "hidden",
		boxSizing: "border-box",
		background: theme.mode === "light" ? "#ffffff" : "#121212",
	},
	chatPapper: {
		display: "flex",
		height: "100%",
		gap: 12,
	},
	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflow: "hidden",
		position: "relative",
		borderRadius: 12,
		background: theme.mode === "light" ? theme.palette.tabHeaderBackground : "#11141b",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		flexGrow: 1,
		overflow: "hidden",
		borderRadius: 12,
		background: theme.mode === "light" ? theme.palette.tabHeaderBackground : "#11141b",
	},
	welcomeMsg: {
		background: theme.mode === "light" ? theme.palette.tabHeaderBackground : "#11141b",
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
	},
	dragger: {
		width: "8px",
		cursor: "ew-resize",
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		zIndex: 100,
		backgroundColor: "transparent",
		userSelect: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"&::after": {
			content: '""',
			width: 4,
			height: 32,
			borderRadius: 4,
			backgroundColor: theme.mode === "light"
				? "rgba(0, 0, 0, 0.15)"
				: "rgba(255, 255, 255, 0.15)",
			transition: "all 0.2s ease",
		},
		"&:hover::after": {
			height: 48,
			backgroundColor: theme.mode === "light"
				? "rgba(0, 0, 0, 0.3)"
				: "rgba(255, 255, 255, 0.3)",
		},
		"&:active::after": {
			height: 48,
			backgroundColor: theme.mode === "light"
				? "rgba(0, 0, 0, 0.4)"
				: "rgba(255, 255, 255, 0.4)",
		},
	},
	logo: {
		logo: theme.logo,
		content: "url(" + (theme.mode === "light" ? theme.calculatedLogoLight() : theme.calculatedLogoDark()) + ")"
	},
}));

const TicketsCustom = () => {
	const { user } = useContext(AuthContext);

	const classes = useStyles({ ticketsManagerWidth: user.defaultTicketsManagerWidth || defaultTicketsManagerWidth });

	const { ticketId } = useParams();

	const initialWidth = (user && user.defaultTicketsManagerWidth) || defaultTicketsManagerWidth;
	const [ticketsManagerWidth, setTicketsManagerWidth] = useState(initialWidth);
	const widthRef = useRef(initialWidth);
	const containerRef = useRef(null);
	const dragging = useRef(false);

	useEffect(() => {
		if (user && user.defaultTicketsManagerWidth) {
			setTicketsManagerWidth(user.defaultTicketsManagerWidth);
			widthRef.current = user.defaultTicketsManagerWidth;
		}
	}, [user]);

	const saveWidth = useCallback(async (value) => {
		const clamped = Math.max(minTicketsManagerWidth, Math.min(maxTicketsManagerWidth, value));
		try {
			await api.put(`/users/toggleChangeWidht/${user.id}`, { defaultTicketsManagerWidth: clamped });
		} catch (e) {}
	}, [user]);

	const handleMouseDown = useCallback((e) => {
		e.preventDefault();
		dragging.current = true;
		document.body.style.cursor = "ew-resize";
		document.body.style.userSelect = "none";

		const onMove = (ev) => {
			if (!dragging.current) return;
			const container = containerRef.current;
			if (!container) return;
			const rect = container.getBoundingClientRect();
			const newWidth = ev.clientX - rect.left;
			if (newWidth >= minTicketsManagerWidth && newWidth <= maxTicketsManagerWidth) {
				widthRef.current = newWidth;
				setTicketsManagerWidth(newWidth);
			}
		};

		const onUp = () => {
			dragging.current = false;
			document.body.style.cursor = "";
			document.body.style.userSelect = "";
			document.removeEventListener("mousemove", onMove, true);
			document.removeEventListener("mouseup", onUp, true);
			saveWidth(widthRef.current);
		};

		document.addEventListener("mousemove", onMove, true);
		document.addEventListener("mouseup", onUp, true);
	}, [saveWidth]);

	return (
		<QueueSelectedProvider>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper} ref={containerRef}>
					<div
						className={classes.contactsWrapper}
						style={{ width: ticketsManagerWidth }}
					>
						<TicketsManager />
						<div onMouseDown={handleMouseDown} className={classes.dragger} />
					</div>
					<div className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								{/* <Suspense fallback={<CircularProgress />}> */}
								<Ticket />
								{/* </Suspense> */}
							</>
						) : (
							<Hidden only={["sm", "xs"]}>
								<Paper square elevation={0} className={classes.welcomeMsg}>
									<span>
										<center>
											<img className={classes.logo} width="50%" alt="" />
										</center>
										{i18n.t("chat.noTicketMessage")}
									</span>								</Paper>
							</Hidden>
						)}
					</div>
				</div>
			</div>
		</QueueSelectedProvider>
	);
};

export default TicketsCustom;